import axios from 'axios';
import { getApiBaseUrl } from '../utils/backendBaseUrl';

const API = getApiBaseUrl();

export async function fetchCommunityStats({ token }) {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const res = await axios.get(`${API}/community/stats`, { headers, timeout: 8000 });
  return res.data || null;
}

export function getCommunityLastSeenAt() {
  try {
    const v = localStorage.getItem('community_last_seen_at');
    return v ? String(v) : '';
  } catch {
    return '';
  }
}

export function setCommunityLastSeenNow() {
  try {
    localStorage.setItem('community_last_seen_at', new Date().toISOString());
  } catch {
    // ignore
  }
}
